import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "folder-open" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2 6C2 4.34315 3.34315 3 5 3H8.92963C9.93269 3 10.8694 3.5013 11.4258 4.3359L12.5352 6L18 6C19.6569 6 21 7.34315 21 9V10.0319C22.1539 10.2395 22.9144 11.4266 22.5488 12.5965L20.8931 17.8948C20.5017 19.1473 19.3418 20 18.0296 20H4.44076C3.09277 20 2 18.9072 2 17.5592V6ZM6.86019 18H18.0296C18.467 18 18.8536 17.7158 18.9841 17.2983L20.6398 12H9.47038C9.033 12 8.64636 12.2842 8.5159 12.7017L6.86019 18ZM19 10H9.47038C8.15823 10 6.99833 10.8527 6.60694 12.1052L4.86146 17.6907C4.80396 17.8747 4.63355 18 4.44076 18C4.19734 18 4 17.8027 4 17.5592V6C4 5.44772 4.44772 5 5 5H8.92963C9.26399 5 9.57622 5.1671 9.76168 5.4453L10.8711 7.1094C11.242 7.6658 11.8665 8 12.5352 8H18C18.5523 8 19 8.44771 19 9V10Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }